import axios from "axios";
import { useEffect, useState } from "react";

interface IGetAutocompleteRequest {
    filter?: string,
}

export interface IGroupData {
    Id: string,
    Name: string,
    Description: string,
    System: boolean,
    AddedBySystem: boolean,

    ExecutorInIssuesCounter: number,
    AssignedInIssuesCounter: number,
    CoordinatorInIssuesCounter: number,
}

type GetAutocompleteApi = [(m: IGetAutocompleteRequest) => void, IGroupData[], boolean, boolean];
export const useGetAllGroupsApi: () => GetAutocompleteApi = () => {
    const [model, setModel] = useState<IGetAutocompleteRequest>(null);
    const [result, setResult] = useState<IGroupData[]>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            setResult(null);
            try {
                const result = await axios.get('/Groups/GetGroupsAutocomplete/', {
                    params: {
                        maxRows: 9000,
                        kind: 'GroupAcl,GroupUser',
                        filter: model.filter,
                    }
                });
                setResult(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!model)
            return;

        fetchData();
    }, [model]);

    return [setModel, result, isLoading, isError];
}

export const useGetVisiblesGroupsApi: () => GetAutocompleteApi = () => {
    const [model, setModel] = useState<IGetAutocompleteRequest>(null);
    const [result, setResult] = useState<IGroupData[]>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            setResult(null);
            try {
                const result = await axios.get('/Groups/GetVisiblesGroupsAutocomplete/', {
                    params: {
                        maxRows: 9000,
                        kind: 'GroupAcl,GroupUser',
                        filter: model.filter,
                    }
                });
                setResult(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!model)
            return;

        fetchData();
    }, [model]);

    return [setModel, result, isLoading, isError];
}